// extracted by mini-css-extract-plugin
export var button = "_72-0";
export var icon = "_72-1";